// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userName {
  position: absolute;
  color: #7F6C2E;
  z-index: 1;
  font-size: 11px;
  margin-left: 10px;
  bottom: 14px;
}
.versionNumber {
  position: absolute;
  color: #7F6C2E;
  z-index: 1;
  font-size: 11px;
  margin-left: 10px;
  bottom: -2px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/module-info/module-info.component.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AADJ;AAIE;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAFJ","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.userName {\n    position: absolute;\n    color: @primary-base;\n    z-index: 1;\n    font-size: 11px;\n    margin-left: 10px;\n    bottom: 14px;\n  }\n  \n  .versionNumber {\n    position: absolute;\n    color: @primary-base;\n    z-index: 1;\n    font-size: 11px;\n    margin-left: 10px;\n    bottom: -2px;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
